import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col } from '../../atoms';
export function KytContent(props) {
    return _jsx(Col, Object.assign({}, props, { style: $.container }));
}
const $ = StyleSheet.create({
    container: {
        marginBottom: theme.spacing['10'],
        rowGap: theme.spacing['2'],
        minWidth: 328,
    },
});
